/**
 * A single labelled figure in a KPI row. Originally local to `DashboardPage`
 * (Task 8); hoisted here once `QuotationsReportPage` (Task 10) needed the same
 * card, rather than duplicating it or importing across page modules.
 */
export function KpiCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-slate-900">{value}</div>
    </div>
  );
}
